import {
  Flex, HStack, Icon, IconButton, Text, Tooltip, VStack,
} from '@chakra-ui/react';
import { get } from '@submize/lodash';
import { useDispatch } from 'react-redux';
import { FaSyncAlt } from 'react-icons/fa';
import ColorPicker from '../../../ColorPicker/ColorPicker';
import { setFieldInputStyles, setFieldPlaceholderStyles } from '../../formSlice';
import InputSetting from '../../../InputSetting';
import TextStyles from '../../../TextStyles';
import BorderSytles from '../../../BorderStyles';
import MoreInputStyles from './moreInputStyles';

const InputSyles = ({ design }) => {
  const dispatch = useDispatch();

  return (
    <VStack color="gray.600" fontSize="sm" gap="3" mt="8">
      <Text fontWeight="bold">Input</Text>

      <Flex justify="space-between" w="100%" alignItems="center">
        <Text>Background</Text>
        <ColorPicker
          color={get(design, 'fields.input.bgcolor', 'transparent')}
          onChange={(color) => dispatch(setFieldInputStyles({ bgcolor: color }))}
        />
      </Flex>
      <BorderSytles
        borderColor={get(design, 'fields.input.borderColor')}
        borderStyle={get(design, 'fields.input.borderStyle')}
        borderWidth={get(design, 'fields.input.borderWidth')}
        onChange={(value) => dispatch(setFieldInputStyles(value))}
      />
      <TextStyles
        fontSize={get(design, 'fields.input.size')}
        fontWeight={get(design, 'fields.input.fontWeight')}
        fontStyle={get(design, 'fields.input.fontStyle')}
        color={get(design, 'fields.input.color', get(design, 'textColor'))}
        onChange={(v) => dispatch(setFieldInputStyles(v))}
      />
      <Flex justify="space-between" w="100%">
        <InputSetting
          label="Padding vertical"
          value={get(design, 'fields.input.paddingY')}
          onChange={(v) => dispatch(setFieldInputStyles({ paddingY: v }))}
          regex={/(^[0-9]+ ?px)?$/}
          errorMessage="Width must be in px"
        />
      </Flex>
      <Flex justify="space-between" w="100%">
        <InputSetting
          label="Padding horizontal"
          value={get(design, 'fields.input.paddingX')}
          onChange={(v) => dispatch(setFieldInputStyles({ paddingX: v }))}
          regex={/(^[0-9]+ ?px)?$/}
          errorMessage="Width must be in px"
        />
      </Flex>
      <Flex justify="space-between" w="100%" alignItems="center">
        <Text>Placeholder</Text>
        <HStack>
          <ColorPicker
            color={get(design, 'fields.placeholder.color', 'transparent')}
            onChange={(c) => dispatch(setFieldPlaceholderStyles({ color: c }))}
          />
          <Tooltip label="Same as text">
            <IconButton icon={<Icon as={FaSyncAlt} />} size="xs" onClick={(() => dispatch(setFieldPlaceholderStyles({ color: false })))} />
          </Tooltip>
        </HStack>

      </Flex>
      <MoreInputStyles design={design} />
    </VStack>
  );
};

export default InputSyles;
